import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from '../shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class LocalsService {

  constructor(private http: HttpClient) { }

  createLocal(body) {
    return this.http.post<ApiResponseModel>('api/local/', body);
  }
  editLocal(uuid, body) {
    return this.http.put<ApiResponseModel>('api/local/' + uuid, body);
  }
  insertLocalProfile(body) {
    return this.http.post<ApiResponseModel>('api/local/profile/', body);
  }
  getLocalProfile(body, uuid) {
    return this.http.post<ApiResponseModel>('api/local/profile/' + uuid, body);
  }
  getLocalByUUID(uuid) {
    return this.http.get<ApiResponseModel>('api/local/profile/' + uuid);
  }
  getAllLocals(query = {}) {
    return this.http.get<ApiResponseModel>('api/local/', {
      params: query
    });
  }
  patchAdminApprovalStatus(body) {
    return this.http.patch<ApiResponseModel>('api/local/state', body);
  }

  getAllCities(id: number) {
    return this.http.get<ApiResponseModel>('api/location/cities?countryId=' + id);
  }
}
